import { useQuery } from '@tanstack/react-query';
import { fetchDealerPeriodStatement } from '../services/dealerFundStatementPeriods';
import type { StatementPeriod } from '../types/dealerFundStatementPeriod.types';
import { openPeriodDay, periodKey } from '../utils/statementPeriod';
import { dealerKeys } from './useDealersQuery';

export function useDealerPeriodStatementQuery(
    dealerId: string,
    period: StatementPeriod,
    todayIso: string,
    enabled: boolean,
) {
    return useQuery({
        queryKey: dealerKeys.fundStatementPeriod(dealerId, periodKey(period), openPeriodDay(period, todayIso)),
        queryFn: () => fetchDealerPeriodStatement(dealerId, period),
        enabled: !!dealerId && enabled,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
    });
}
